export function checked(givenValue) {
    return Boolean(givenValue);
}
//# sourceMappingURL=checked.js.map